import React, { useEffect, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
function getTimeUntilMidnight() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  return Math.max(0, midnight.getTime() - now.getTime());
}
function formatCountdown(milliseconds: number) {
  const totalSeconds = Math.ceil(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
}
export function AnnouncementBar() {
  const [remainingTime, setRemainingTime] = useState(getTimeUntilMidnight);
  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setRemainingTime(getTimeUntilMidnight());
    }, 1000);
    return () => window.clearInterval(intervalId);
  }, []);
  const countdown = formatCountdown(remainingTime);
  return <div className="w-full bg-gold text-deep-blue" data-id="element-16" data-mp="689ufwta8n3q">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-3 py-1 text-center" data-id="element-17" data-mp="67gxtoo1fdzb">
        <Clock3Icon className="h-3.5 w-3.5 flex-none" aria-hidden="true" data-id="element-18" data-mp="aan2wszeyz47" />
        <p className="text-[11px] font-extrabold uppercase tracking-wide sm:text-xs" data-id="element-19" data-mp="3sg9so26f0dmc">
          Solo por hoy
        </p>
        <time dateTime={`PT${countdown}`} className="rounded bg-deep-blue px-1.5 py-0.5 font-mono text-[11px] font-bold tracking-wider text-white sm:text-xs" aria-label={`La oferta termina en ${countdown}`} data-id="element-20" data-mp="19ylrpeq4in3">
          {countdown}
        </time>
      </div>
    </div>;
}